// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d9daad2e","239":"679a2c97","452":"766b6cf2","455":"5f4baf47"}[chunkId] + ".chunk.js";
};